import { Icon, Image } from "@chakra-ui/react";
import { HiUsers } from "react-icons/hi";
import {
  MdContacts,
  MdHome,
  MdInsertChartOutlined,
  MdLeaderboard,
  MdLock,
  MdSettings,
} from "react-icons/md";
// icon
import React from "react";
import { AiFillFolderOpen, AiOutlineMail } from "react-icons/ai";
import { FaCalendarAlt, FaRupeeSign, FaTasks, FaWpforms } from "react-icons/fa";
import { LuBuilding2 } from "react-icons/lu";
import { PiPhoneCallBold } from "react-icons/pi";
import { FaCreativeCommonsBy } from "react-icons/fa";
import { SiGooglemeet } from "react-icons/si";
import ChangeImage from "common/components/image";
import Validation from "common/components/validation";
import CustomField from "common/components/customField";
import TableField from "common/components/tableField";
import { TbExchange, TbTableColumn } from "react-icons/tb";
import { GrValidate } from "react-icons/gr";
import { VscFileSubmodule } from "react-icons/vsc";
import { FiEye } from "react-icons/fi";
import { EditIcon, LockIcon } from "@chakra-ui/icons";

import crmIcon from "services/Crm/assets/img/crmIcon.png";
import passwordIcon from "services/Crm/assets/img/passwordIcon.png";
import passwordIconFDark from "common/assets/img/passwordIconDark.png";
import crmIconDark from "common/assets/img/crmIconDark.png";
import recruitmentIcon from "services/Crm/assets/img/RecruitmentIcon.png";
import departmentIcon from "services/Crm/assets/img/departmentIcon.png";
import projectIcon from "services/Crm/assets/img/projectIcon.png";
import assetTrackingIcon from "services/Crm/assets/img/assetTracking.png";
import reportIcon from "services/Crm/assets/img/reportsIcon.png";
import HomePage from "services/Crm/pages/home";
import { ROLE_PATH } from "common/roles";
import { constant } from "./constant";
import RecruitHomePage from "services/Recruit/pages/home";
import Interview from "services/Recruit/pages/interview";
import CreateInterview from "services/Recruit/pages/interviewCreate";
import Referrals from "services/Recruit/pages/referals";
import DepartmentCreate from "services/Recruit/pages/departmentCreate";
import ReferralsCreate from "services/Recruit/pages/referralsCreate";
import CampaignCreate from "services/Recruit/pages/campaignCreate";
import Campaign from "services/Recruit/pages/campgain";
import { recruitConstant } from "services/Recruit/constant";
import Application from "services/Recruit/pages/application";
import ApplicationCreate from "services/Recruit/pages/applicationCreate";
import Candidates from "services/Recruit/pages/candidates";
import CandidatesCreate from "services/Recruit/pages/candidatesCreate";
import Offers from "services/Recruit/pages/offers";
import CreateTask from "services/Crm/pages/task/createTask";
import CreateMeeting from "./modules/meeting/createMeeting";
import CreateCallLogs from "./modules/phoneCall/createCallLog";
import CreateLead from "services/Crm/pages/lead/createLead";
import CreateContact from "services/Crm/pages/contact/createContact";
import CreateEmail from "services/Crm/pages/emailHistory/createEmail";
import Panel from "services/Recruit/pages/pannel";
import PanelCreate from "services/Recruit/pages/panelCreate";
import BgVerification from "services/Recruit/pages/bgVerification";
import BgVerificationCreate from "services/Recruit/pages/bgVerificationCreate.js";
import CreateDynamic from "./components/dynamicPage/create";
import CreatePassword from "services/Vault/pages/MyPassword/create";
import LandingPage from "./landingPage";
import CreateWorkspace from "./createWorkspace";
import CreateWorkflowRule from "services/Crm/pages/WorkflowRules/CreateWorkflowRule";
import WorkflowRules from "services/Crm/pages/WorkflowRules";
import EditWorkflow from "services/Crm/pages/WorkflowRules/editWorkflowRule";
import PrivacyPolicy from "./privacyPolicy";

import CreateProperty from "services/Crm/pages/property/createProperty";
import OverviewPage from "common/components/OverviewPage";
import SupportPage from "common/components/SupportPage";

//Department
const Department = React.lazy(() =>
  import("services/Recruit/pages/department")
);
//Job Profile
const JobProfile = React.lazy(() =>
  import("services/Recruit/pages/jobProfile")
);

const CreateOfferLatter = React.lazy(() =>
  import("services/Recruit/pages/offerLetterCreate")
);
// Admin Imports
const MainDashboard = React.lazy(() => import("common/components/default"));

const ShareByMePassword = React.lazy(() =>
  import("services/Vault/components/passwords/SharedByMe")
);

const ShareWithMePassword = React.lazy(() =>
  import("services/Vault/pages/ShareWithMePassword")
);

const MyPassword = React.lazy(() => import("services/Vault/pages/MyPassword"));
const passwordView = React.lazy(() =>
  import("services/Vault/components/passwords/AllPasswordView")
);
const sharedByMePasswordView = React.lazy(() =>
  import("services/Vault/components/passwords/SharedByMeView")
);
const sharedWithMePasswordView = React.lazy(() =>
  import("services/Vault/components/passwords/SharedWithMeView")
);
const allPasswordShare = React.lazy(() =>
  import("services/Vault/components/passwords/AllPasswordShare")
);
// All Password
// My component
const SSORedirect = React.lazy(() => import("common/components/SSORedirect"));
const Contact = React.lazy(() => import("services/Crm/pages/contact"));
const ContactView = React.lazy(() =>
  import("services/Crm/components/contact/View")
);
const ContactImport = React.lazy(() =>
  import("services/Crm/components/contact/ContactImport")
);

const User = React.lazy(() => import("common/modules/users"));
const UserView = React.lazy(() => import("common/modules/users/View"));

const Property = React.lazy(() => import("services/Crm/pages/property"));
const PropertyView = React.lazy(() =>
  import("services/Crm/components/property/View")
);
const PropertyImport = React.lazy(() =>
  import("services/Crm/components/property/PropertyImport")
);

const Lead = React.lazy(() => import("services/Crm/pages/lead"));
const LeadView = React.lazy(() => import("services/Crm/components/lead/View"));
const LeadImport = React.lazy(() =>
  import("services/Crm/components/lead/LeadImport")
);

const Task = React.lazy(() => import("services/Crm/pages/task"));
const TaskView = React.lazy(() =>
  import("services/Crm/components/task/taskView")
);
const Calender = React.lazy(() => import("common/modules/calender"));
// const Payments = React.lazy(() => import("views/admin/payments"));
const Role = React.lazy(() => import("common/components/role"));

const EmailHistory = React.lazy(() =>
  import("services/Crm/pages/emailHistory")
);
const EmailHistoryView = React.lazy(() =>
  import("services/Crm/components/emailHistory/View")
);

const Meeting = React.lazy(() => import("common/modules/meeting"));
const MettingView = React.lazy(() => import("common/modules/meeting/View"));

const PhoneCall = React.lazy(() => import("common/modules/phoneCall"));
const CustomDashboard = React.lazy(() =>
  import("services/Crm/pages/CustomDashboard")
);
const PhoneCallView = React.lazy(() => import("common/modules/phoneCall/View"));

const Report = React.lazy(() => import("common/modules/reports"));

const CreateJobOpening = React.lazy(() =>
  import("services/Recruit/pages/jobProfileCreate")
);
// Auth Imports
const SignInCentered = React.lazy(() => import("auth/signIn"));
const ForgotPassword = React.lazy(() => import("auth/forgotPassword"));
const ResetPassword = React.lazy(() => import("auth/resetPassword"));
// admin setting
const AdminSetting = React.lazy(() => import("common/components/adminSetting"));
const validation = React.lazy(() => import("common/components/validation"));
const module = React.lazy(() => import("common/components/moduleName"));

export const userRoutes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ForgotPassword,
  },
  // {
  //   name: "Home",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/home",
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: HomePage,
  // },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "/reset-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ResetPassword,
  },
  {
    name: "CRM",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/default",
    icon: (
      <Image
        objectFit="cover"
        src={crmIconDark}
        style={{ opacity: "1" }}
        h="16px"
        w="16px"
      />
    ),
    component: MainDashboard,
  },
  {
    name: "Vault",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/password/my-password",
    icon: (
      <Image
        objectFit="cover"
        src={passwordIconFDark}
        style={{ opacity: "1" }}
        h="16px"
        w="16px"
      />
    ),
    component: MyPassword,
  },
  // {
  //   name: "Recruitment",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/recruit/dashboard",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={recruitmentIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },
  // {
  //   name: "All Password ",
  //   layout: [ROLE_PATH.user],
  //   under: "password/my-password",
  //   path: "/password/viewSharedByMePassword/:id",
  //   component: sharedByMePasswordView,
  // },
  // {
  //   name: "All Password ",
  //   layout: [ROLE_PATH.user],
  //   under: "password/my-password",
  //   path: "/password/passwordList/:id",
  //   component: passwordView,
  // },
];
export const homeRoutes = [
  // ========================== Onboarding ==========================
  {
    name: "Landing Page",
    layout: "/",
    path: "/",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />, // optional
    component: <LandingPage />,
  },
  {
    name: "Workspace",
    layout: "/",
    path: "/createWorkspace",
    icon: "",
    component: <CreateWorkspace />,
  },
  {
    name: "Privacy Policy",
    layout: "/",
    path: "/privacyPolicy",
    icon: "",
    component: <PrivacyPolicy />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/auth/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/auth/forgot-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ForgotPassword,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "/auth/reset-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ResetPassword,
  },
  // ========================== Sub-Application Routes ==========================

  // {
  //   name: "Home",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/home",
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   component: HomePage,
  // },
  {
    name: "CRM",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/default",
    icon: (
      <Image
        objectFit="cover"
        src={crmIconDark}
        style={{ opacity: "1" }}
        h="16px"
        w="16px"
      />
    ),
    component: MainDashboard,
  },
  {
    name: "Vault",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/password/my-password",
    icon: (
      <Image
        objectFit="cover"
        src={passwordIconFDark}
        style={{ opacity: "1" }}
        h="16px"
        w="16px"
      />
    ),
    component: MainDashboard,
  },
  // {
  //   name: "Recruitment",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/recruit/dashboard",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={recruitmentIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },
  // {
  //   name: "Departments",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/department",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={departmentIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },

  // // extras
  // {
  //   name: "Projects",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/projects",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={projectIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },
  // {
  //   name: "Asset Tracking",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/asset-tracking",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={assetTrackingIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },
  // {
  //   name: "Reports",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/reports",
  //   icon: (
  //     <Image
  //       objectFit="cover"
  //       src={reportIcon}
  //       style={{ opacity: "1" }}
  //       h="20px"
  //       w="20px"
  //     />
  //   ),
  //   component: MainDashboard,
  // },
];
const routes = [
  // ========================== Dashboard ==========================
  {
    name: "Home",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/default",
    icon: (
      <Icon
        as={MdHome}
        width="20px"
        height="20px"
        color="inherit"
        title="Dashboard"
      />
    ),
    component: MainDashboard,
  },

  {
    name: "Overview",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/overview",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: OverviewPage,
  },
  {
    name: "Support",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/support",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: SupportPage,

  },

  // ------------- redirect ------------------------
  // {
  //   name: "Redirect Spa",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/redirect_spa",
  //   icon: (
  //     <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
  //   ),
  //   component: SSORedirect,
  // },
  // ========================== Admin Layout ==========================
  // ------------- lead Routes ------------------------
  {
    name: "Leads",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/leads",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Lead,
  },
  {
    name: "Leads",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/leads",
    parentName: "Leads",
    path: "/crm/leads/leadView/:id",
    component: LeadView,
  },
  {
    name: "Lead Import",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/leads",
    parentName: "Leads",
    path: "/crm/leads/leadImport",
    component: LeadImport,
  },
  // --------------- contact Routes --------------------
  {
    name: "Contacts",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/contacts",
    icon: <Icon as={MdContacts} width="20px" height="20px" color="inherit" />,
    component: Contact,
  },
  {
    name: "Contacts",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/contacts",
    parentName: "Contacts",
    path: "/crm/contacts/contactView/:id",
    component: ContactView,
  },
  {
    name: "Create Task",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/tasks",
    parentName: "Tasks",
    path: "/crm/tasks/createTask",
    component: CreateTask,
  },
  {
    name: "Create Meeting",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/meeting",
    parentName: "Meetings",
    path: "/crm/meeting/createMeeting",
    component: CreateMeeting,
  },
  {
    name: "Create Call Log",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/phone-call",
    parentName: "Calls",
    path: "/crm/phone-call/createCallLog",
    component: CreateCallLogs,
  },
  {
    name: "Create Lead",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/leads",
    parentName: "Leads",
    path: "/crm/leads/createLead",
    component: CreateLead,
  },
  {
    name: "Create Contact",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/contacts",
    parentName: "Calls",
    path: "/crm/contacts/createContact",
    component: CreateContact,
  },
  {
    name: "Create Property",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/products",
    parentName: "Products",
    path: "/crm/products/createProduct",
    component: CreateProperty,
  },
  {
    name: "Create Email",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/email",
    parentName: "Emails",
    path: "/crm/email/createEmail",
    component: CreateEmail,
  },
  {
    name: "Contact Import",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    both: true,
    under: "/crm/contacts",
    parentName: "Contacts",
    path: "/crm/contacts/contactImport",
    component: ContactImport,
  },
  // ------------- Property Routes ------------------------
  {
    name: "Products",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/products",
    icon: <Icon as={LuBuilding2} width="20px" height="20px" color="inherit" />,
    component: Property,
  },
  {
    name: "Products View ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: "Products",
    under: "products",
    path: "/crm/products/productView/:id",
    component: PropertyView,
  },
  {
    name: "Property Import",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    both: true,
    under: "products",
    parentName: "Products",
    path: "/crm/products/productImport",
    component: PropertyImport,
  },
  // -----------------------------Admin setting-------------------------------------
  // {
  //   name: "Admin Setting",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   parentName: "admin",
  //   under: "admin",
  //   path: "/crm/admin-setting",
  //   component: AdminSetting,
  // },

  // ------------- Task Routes ------------------------
  {
    name: "Tasks",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/tasks",
    icon: <Icon as={FaTasks} width="20px" height="20px" color="inherit" />,
    component: Task,
  },
  {
    name: "Tasks",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/tasks",
    parentName: "Tasks",
    path: "/crm/tasks/taskView/:id",
    component: TaskView,
  },
  // ------------- Meeting Routes ------------------------
  {
    name: "Meetings",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/meeting",
    icon: <Icon as={SiGooglemeet} width="20px" height="20px" color="inherit" />,
    component: Meeting,
  },
  {
    name: "Meetings ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/meeting",
    parentName: "Meetings",
    path: "/crm/meeting/:id",
    component: MettingView,
  },
  // ------------- Phone Routes ------------------------
  {
    name: "Calls",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/phone-call",
    icon: (
      <Icon as={PiPhoneCallBold} width="20px" height="20px" color="inherit" />
    ),
    component: PhoneCall,
  },
  {
    name: "Calls",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/crm/phone-call",
    parentName: "Calls",
    path: "/crm/phone-call/:id",
    component: PhoneCallView,
  },
  // ------------- Custom Dashboard Routes ------------------------
  // {
  //   name: "Customize Dashboard",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/custom-dashboard",
  //   icon: <Icon as={EditIcon} width="20px" height="20px" color="inherit" />,
  //   component: CustomDashboard,
  // },
  // ------------- Email Routes------------------------
  {
    // separator: 'History',
    name: "Emails",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/email",
    icon: (
      <Icon as={AiOutlineMail} width="20px" height="20px" color="inherit" />
    ),
    component: EmailHistory,
  },
  {
    name: "Emails ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "Emails",
    parentName: "Emails",
    path: "/crm/email/:id",
    component: EmailHistoryView,
  },
  // ------------- Calender Routes ------------------------
  {
    name: "Calendar",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/calendar",
    icon: (
      <Icon as={FaCalendarAlt} width="20px" height="20px" color="inherit" />
    ),
    component: Calender,
  },
  // ------------- Payments Routes ------------------------
  // {
  //   name: "Payments",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/payments",
  //   icon: <Icon as={FaRupeeSign} width='20px' height='20px' color='inherit' />,
  //   component: Payments,
  // },

  // ------------- Roles Routes ------------------------
  // {
  //   name: "Roles",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/role",
  //   under: "role",
  //   icon: (
  //     <Icon
  //       as={FaCreativeCommonsBy}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   component: Role,
  // },
  // {
  //   name: "Custom Fields",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/custom-Fields",
  //   under: "customField",
  //   icon: <Icon as={FaWpforms} width="20px" height="20px" color="inherit" />,
  //   component: CustomField,
  // },
  // {
  //   name: "Change Images",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/change-images",
  //   under: "image",
  //   icon: <Icon as={TbExchange} width="20px" height="20px" color="inherit" />,
  //   component: ChangeImage,
  // },
  // {
  //   name: "Validation",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/validations",
  //   under: "Validation",
  //   icon: <Icon as={GrValidate} width="20px" height="20px" color="inherit" />,
  //   component: Validation,
  // },
  // {
  //   name: "Table Fields",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/table-field",
  //   under: "tableField",
  //   icon: (
  //     <Icon as={TbTableColumn} width="20px" height="20px" color="inherit" />
  //   ),
  //   component: TableField,
  // },
  // {
  //   name: "Module",
  //   layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
  //   path: "/crm/module",
  //   under: "module",
  //   icon: (
  //     <Icon as={VscFileSubmodule} width="20px" height="20px" color="inherit" />
  //   ),
  //   component: module,
  // },
  // // ------------- Text message Routes ------------------------
  // {
  //   name: "Text Msg",
  //   layout: [ROLE_PATH.admin, ROLE_PATH.user],
  //
  //   path: "/text-msg",
  //   icon: <Icon as={MdOutlineMessage} width='20px' height='20px' color='inherit' />,
  //   component: TextMsg,
  // },
  // {
  //   name: "Text Msg View",
  //   layout: [ROLE_PATH.admin, ROLE_PATH.user],
  //
  //   under: "text-msg",
  //   path:  text-msg/:id",
  //   component: TextMsgView,
  // },

  // ----------------- Reporting Layout -----------------
  {
    name: "Reporting & Analytics",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/reporting-analytics",
    icon: (
      <Icon
        as={MdInsertChartOutlined}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: Report,
  },
  // ------------- user Routes ------------------------
  {
    name: "Users",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/crm/user",
    under: "user",
    icon: <Icon as={HiUsers} width="20px" height="20px" color="inherit" />,
    component: User,
  },
  {
    name: "User View",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: "Email",
    under: "user",
    path: "/crm/userView/:id",
    component: UserView,
  },
  {
    name: "User View",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: "Email",
    under: "user",
    path: "/userView/:id",
    component: UserView,
  },
  // ========================== User layout ==========================

  // ========================== auth layout ==========================
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ForgotPassword,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "/crm/reset-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ResetPassword,
  },
  {
    name: "Workflow Rules",
    layout: [ROLE_PATH.superAdmin],
    path: "/crm/workflow-rules",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: WorkflowRules,
  },
  {
    name: "Create Workflow Rule",
    layout: [ROLE_PATH.superAdmin],
    under: "/crm/workflow-rules",
    parentName: "Workflow Rules",
    path: "/crm/workflow-rules/create",
    component: CreateWorkflowRule,
  },
  {
    name: "Edit Workflow Rule",
    layout: [ROLE_PATH.superAdmin],
    under: "/crm/tasks",
    parentName: "Tasks",
    path: "/crm/workflow-rules/:id",
    component: EditWorkflow,
  },
];
export const vaultRoutes = [
  // ------------- All Password Routes ------------------------
  {
    name: "My Passwords",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/password/my-password",
    icon: <Icon as={LockIcon} width="20px" height="20px" color="inherit" />,
    component: MyPassword,
  },
  {
    name: "Create Password",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "password/my-password",
    path: "/password/my-password/create",
    component: CreatePassword,
  },
  {
    name: "View Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "password/my-password",
    parentName: "All Password",
    path: "/password/my-password/passwordList/:id",
    component: passwordView,
  },
  {
    name: "Share Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "password/my-password",
    parentName: "All Password",
    path: "/password/my-password/sharePassword/:id",
    component: allPasswordShare,
  },

  {
    name: "Shared With Me",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/password/share-with-me",
    icon: <Icon as={LockIcon} width="20px" height="20px" color="inherit" />,
    component: ShareWithMePassword,
  },
  {
    name: "View Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/password/share-with-me",
    parentName: "All Password",
    path: "/password/share-with-me/passwordList/:id",
    component: passwordView,
  },
  {
    name: "Share Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/password/share-with-me",
    parentName: "All Password",
    path: "/password/share-with-me/sharePassword/:id",
    component: allPasswordShare,
  },
  {
    name: "Shared By Me",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/password/share-by-me",
    icon: <Icon as={LockIcon} width="20px" height="20px" color="inherit" />,
    component: ShareByMePassword,
  },
  {
    name: "View Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/password/share-by-me",
    parentName: "All Password",
    path: "/password/share-by-me/passwordList/:id",
    component: passwordView,
  },

  {
    name: "Share Password ",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/password/share-by-me",
    parentName: "All Password",
    path: "/password/share-by-me/viewSharedByMePassword/:id",
    component: sharedByMePasswordView,
  },
];
export const commonRoutes = [
  // -----------------------------Admin setting-------------------------------------
  {
    name: "Admin Setting",
    layout: [ROLE_PATH.superAdmin],
    parentName: "admin",
    under: "/crm",
    path: "/admin-setting",
    component: AdminSetting,
  },
  {
    name: "Overview",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/overview",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: OverviewPage,
  },
  {
    name: "Support",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/support",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: SupportPage,
  },
  // ------------- Roles Routes ------------------------
  {
    name: "Roles",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/role",
    under: "role",
    icon: (
      <Icon
        as={FaCreativeCommonsBy}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: Role,
  },
  {
    name: "Custom Fields",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/custom-Fields",
    under: "customField",
    icon: <Icon as={FaWpforms} width="20px" height="20px" color="inherit" />,
    component: CustomField,
  },
  {
    name: "Change Images",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/change-images",
    under: "image",
    icon: <Icon as={TbExchange} width="20px" height="20px" color="inherit" />,
    component: ChangeImage,
  },
  {
    name: "Validation",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/validations",
    under: "Validation",
    icon: <Icon as={GrValidate} width="20px" height="20px" color="inherit" />,
    component: Validation,
  },
  {
    name: "Table Fields",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/table-field",
    under: "tableField",
    icon: (
      <Icon as={TbTableColumn} width="20px" height="20px" color="inherit" />
    ),
    component: TableField,
  },
  {
    name: "Module",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/module",
    under: "module",
    icon: (
      <Icon as={VscFileSubmodule} width="20px" height="20px" color="inherit" />
    ),
    component: module,
  },
  // ------------- user Routes ------------------------
  {
    name: "Users",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/user",
    under: "user",
    icon: <Icon as={HiUsers} width="20px" height="20px" color="inherit" />,
    component: User,
  },
  {
    name: "User View",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: "Email",
    under: "user",
    path: "/userView/:id",
    component: UserView,
  },
  // ------------- redirect ------------------------

  {
    name: "Redirect Spa",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/redirect_spa",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: SSORedirect,
  },
];
export const departmentRoutes = [
  // ------------- Department Routes ------------------------
  {
    name: "Departments",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/department",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Department,
  },
];
export const recruitmentRoutes = [
  // 1. Home
  {
    name: "Home",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/dashboard",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: RecruitHomePage,
  },

  // 2. Job Openings
  {
    name: constant.jobOpenings,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/jobProfile",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: JobProfile,
  },
  {
    name: constant.jobOpenings,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/jobProfile",
    parentName: constant.jobOpenings,
    path: "/recruit/jobProfileCreate",
    component: CreateJobOpening,
  },
  {
    name: constant.jobOpenings,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/jobProfile",
    parentName: constant.jobOpenings,
    path: "/recruit/jobProfileCreate/:id",
    component: CreateJobOpening,
  },

  // 3. Application
  {
    name: recruitConstant.application,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/application",
    icon: <Icon as={LockIcon} width="20px" height="20px" color="inherit" />,
    component: Application,
  },
  {
    name: recruitConstant.createApplication,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/application",
    parentName: recruitConstant.application,
    path: "/recruit/applicationCreate",
    component: ApplicationCreate,
  },
  {
    name: recruitConstant.createApplication,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/application",
    parentName: recruitConstant.application,
    path: "/recruit/applicationCreate/:id",
    component: ApplicationCreate,
  },

  // 4. Candidates
  {
    name: recruitConstant.candidates,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/candidates",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Candidates,
  },
  {
    name: constant.createCandidate,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/candidates",
    parentName: constant.createCandidate,
    path: "/recruit/candidatesCreate",
    component: CandidatesCreate,
  },
  {
    name: constant.createCandidate,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/candidates",
    parentName: constant.createCandidate,
    path: "/recruit/candidatesCreate/:id",
    component: CandidatesCreate,
  },

  // 5. Interviews
  {
    name: recruitConstant.interviews,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/Interview",
    icon: <Icon as={LockIcon} width="20px" height="20px" color="inherit" />,
    component: Interview,
  },
  {
    name: constant.createInterview,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/Interview",
    parentName: constant.interview,
    path: "/recruit/InterviewCreate",
    component: CreateInterview,
  },
  {
    name: constant.createInterview,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/Interview",
    parentName: constant.interview,
    path: "/recruit/InterviewCreate/:id",
    component: CreateInterview,
  },

  // 6. Referrals
  {
    name: constant.referrals,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/referrals",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Referrals,
  },
  {
    name: constant.referrals,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/referralsCreate",
    parentName: constant.referrals,
    path: "/recruit/referralsCreate",
    component: ReferralsCreate,
  },
  {
    name: constant.referrals,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/referralsCreate",
    parentName: constant.referrals,
    path: "/recruit/referralsCreate/:id",
    component: ReferralsCreate,
  },

  // 7. Departments
  {
    name: recruitConstant.departments,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    path: "/recruit/department",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Department,
  },
  {
    name: constant.createDepartment,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/department",
    parentName: constant.department,
    path: "/recruit/departmentCreate",
    component: DepartmentCreate,
  },
  {
    name: constant.createDepartment,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/department",
    parentName: constant.department,
    path: "/recruit/departmentCreate/:id",
    component: DepartmentCreate,
  },

  // 8. Campaigns
  {
    name: recruitConstant.campaigns,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: constant.campaign,
    path: "/recruit/campaign",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Campaign,
  },
  {
    name: constant.createCampaign,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/campaign",
    parentName: constant.campaign,
    path: "/recruit/campaignCreate/:id",
    component: CampaignCreate,
  },
  {
    name: constant.createCampaign,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/campaign",
    parentName: constant.campaign,
    path: "/recruit/campaignCreate",
    component: CampaignCreate,
  },

  // 9. Offer Letters
  {
    name: recruitConstant.offers,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: recruitConstant.offers,
    path: "/recruit/offer",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Offers,
  },
  {
    name: recruitConstant.offer,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/offer",
    parentName: recruitConstant.offer,
    path: "/recruit/offerLetterCreate/:id",
    component: CreateOfferLatter,
  },
  {
    name: recruitConstant.offer,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/offer",
    parentName: recruitConstant.offer,
    path: "/recruit/offerLetterCreate",
    component: CreateOfferLatter,
  },
  {
    name: recruitConstant.panels,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: recruitConstant.panels,
    path: "/recruit/panel",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: Panel,
  },
  {
    name: recruitConstant.panels,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/panel",
    parentName: recruitConstant.panels,
    path: "/recruit/panelCreate/:id",
    component: PanelCreate,
  },
  {
    name: recruitConstant.panels,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/panel",
    parentName: recruitConstant.panels,
    path: "/recruit/panelCreate",
    component: PanelCreate,
  },
  {
    name: recruitConstant.bgVerification,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    parentName: recruitConstant.bgVerification,
    path: "/recruit/bgVerification",
    icon: (
      <Icon as={MdLeaderboard} width="20px" height="20px" color="inherit" />
    ),
    component: BgVerification,
  },
  {
    name: recruitConstant.bgVerification,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/bgVerification",
    parentName: recruitConstant.bgVerification,
    path: "/recruit/bgVerificationCreate/:id",
    component: BgVerificationCreate,
  },
  {
    name: recruitConstant.bgVerification,
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user],
    under: "/recruit/bgVerification",
    parentName: recruitConstant.bgVerification,
    path: "/recruit/bgVerificationCreate",
    component: BgVerificationCreate,
  },
];

export default routes;
